import callApi from "Common/utils/apiCaller";
import React, { useEffect, useState } from "react";
import _, { set } from "lodash";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import EditableView from "./EditableView";
import { ToastContainer } from "react-toastify";
import Drawer from "Common/Components/Drawer";
import SegmentOrderModal from "./SegmentOrderModal/SegmentOrderModal";
import { segmentTemplates } from "pages/Job/template";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showNotification } from "Common/utils/Notification";
import { PAGE_LIST_ROUTE } from "constants/routeEnum";
import HtmlCode from "Common/Components/HtmlCode/HtmlCode";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import MetaData from "Common/MetaData";

// const segment_keys = [
//   "home_banner_segments",
//   "banner_segments",
//   "award_segments",
//   "scroll_segments",
//   "contact_us_segments",
//   "blog_segments",
//   "code_segments",
//   "video_segments",
//   "description_segments",
//   "value_segments",
//   "solution_segments",
//   "number_scroll_segments",
//   "faq_segments",
//   "twocolumn_segments",
//   "twocolumnscroll_segments",
//   "pressrelease_segments",
//   "people_segments",
//   "collection_segments",
//   "split_segments",
//   "newsletter_segments",
//   "news_segments",
//   "podcast_segments",
//   //"experience_segments",
//   "cookies_segments",
// ];

const PageView = () => {
  document.title = "pages | ant";

  const { pageId } = useParams();
  const [metaEdit, setMetaEdit] = useState<any>({
    url: "",
    page_title: "",
    meta_description: "",
    meta_keyword: "",
    canonical_url: "",
  });
  const [errors, setErrors] = useState<any>();
  const [version, setVersion] = useState<any>([]);
  const [showMeta, setShowMeta] = useState<any>(false);
  const toggleMeta = () => setShowMeta(!showMeta);
  const [show, setShow] = useState<any>(false);
  const toggle = () => setShow(!show);
  const [pageView, setPageView] = useState<any>();
  const [segmentData, setSegmentData] = useState([]);
  const [segmentList, setSegmentList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState("");
  const [segments, setSegments] = useState([]);
  const [collapse, setCollapse] = useState([]);
  const [content, setContent] = useState("");
  const [versionCopyObject, setVersionCopyObject] = useState({});
  const [showApprove, setShowApprove] = useState(false);
  const toogleApprove = () => setShowApprove(!showApprove);

  const [isOrderVisible, setIsOrderVisible] = useState(false);

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
      permission: profile.permission,
    })
  );

  const { error, success, user, permission } = useSelector(selectProperties);

  const userHasPermissionToEditPage = () => {
    return permission?.permissions?.includes("page:edit");
  };

  const userHasPermissionToApprovePage = () => {
    return permission?.permissions?.includes("page:verify");
  };

  const userHasPermissionToPublishPage = () => {
    return permission?.permissions?.includes("page:publish");
  };

  useEffect(() => {
    fetchPageView();
    fetchVersionList(pageId);
  }, [pageId, loader]);

  const fetchVersionList = async (id) => {
    try {
      const res = await callApi(`v1/page/${id}/unfrozen-copies`, "get", {});
      if (res && res?.status === "Success" && res?.data?.copies.length > 0 ) {
        setVersion(res.data?.copies);
      }
    } catch (e) {}
  };

  const fetchPageView = async () => {
    try {
      const localData = await callApi("v1/editableview/list", "post", {});
      let arr = [];
      if (localData?.status === "Success") {
        for (let item of localData.data.editableviewList) {
          arr.push(item.slug);
        }
        let res = await callApi(`v1/page/${pageId}`, "get");
        let versionCopyRes = await callApi(
          `v1/page/${pageId}/version-list`,
          "post",
          {}
        );
        if (res && res.status === "Success") {
          setMetaEdit(res?.data?.page);
          let pageDataResult = await callApi(
            `v1/page/url/${res?.data?.page?.url}/detailed-info`,
            "get"
          );
          if (versionCopyRes.status === "Success") {
            
            if (versionCopyRes.data.count === 0) {
              let newSegmentData = [];
              let page = pageDataResult.data.page;
              arr?.forEach((segmentKey) => {
                if (page[segmentKey] && page[segmentKey].length > 0) {
                  page[segmentKey].forEach((pageSegment) => {
                    newSegmentData[pageSegment._id] = {
                      data: pageSegment,
                      segment_type: segmentKey,
                    };
                  });
                }
              });
              setSegmentList(arr);
              setPageView(pageDataResult.data.page);
              setContent(pageDataResult.data.page?.meta_keyword);
              setSegmentData(newSegmentData);
            } else {
              let copyDocuments = versionCopyRes.data.documents;
              let copyObject = {};
              copyDocuments.forEach((objectItem) => {
                copyObject[objectItem.original_id] = objectItem;
              });
              let newSegmentData = [];
              let page = pageDataResult.data.page;
              arr?.forEach((segmentKey) => {
                if (page[segmentKey] && page[segmentKey].length > 0) {
                  page[segmentKey].forEach((pageSegment) => {
                    newSegmentData[pageSegment._id] = {
                      data: pageSegment,
                      segment_type: segmentKey,
                    };
                  });
                }
              });
              setSegmentList(arr);

              setPageView(pageDataResult.data.page);
              setContent(pageDataResult.data.page?.meta_keyword);
              setSegmentData(newSegmentData);
              setVersionCopyObject(copyObject);
            }
          }
        }
      }
    } catch (e) {
      showNotification("error occured", "error");
    }
  };

  // console.log(segmentList);

  // Handle segment selection
  const handleSegmentChange = (e) => {
    setSelectedSegment(e.target.value);
  };

  const handleshowSagment = (index) => {
    if (collapse.some((item) => item === index)) {
      setCollapse(collapse.filter((item) => item !== index));
    } else {
      let array = [...collapse];
      array.push(index);
      setCollapse(array);
    }
  };

  // Add the selected segment to the array
  const handleAddSegment = async () => {
    if (!selectedSegment) {
      alert("Please select a segment");
      return;
    }

    const segmentDataToAdd = segmentTemplates[selectedSegment];

    try {
      const bannerSegmentResult = await callApi(
        `v1/page/${pageId}/add-segment`,
        "post",
        segmentDataToAdd
      );
      fetchPageView();

      if (bannerSegmentResult?.success) {
        showNotification("Segment added successfully", "success");
      } else {
      }
    } catch (error) {
      showNotification("Error adding segment:", "error");
    }
  };

  // Handle deleting a segment
  const handleDelete = async (id, type) => {
    try {
      const bannerSegmentResult = await callApi(
        `v1/page/${pageId}/segment/${id}/remove-segment`,
        "post",
        { segment_type: type }
      );

      if (bannerSegmentResult.status === "Success") {
        setLoader(!loader);
        toast(" Removed segment successfully");
      } else {
        // toast.error("Failed to remove segment");
      }
    } catch (error) {
      toast.error("Error removing segment");
      console.error("Error removing segment:");
    }
  };

  const handlePublish = async () => {
    if (!pageView) {
      showNotification("Page data is missing. Please try again.", "error");
      return;
    }
    try {
      const response = await callApi(`v1/page/${pageView?.url}/publish`, "get");
      if (response?.status === "Success") {
        setLoader(!loader);
        showNotification("Page published successfully", "success");
        fetchPageView();
        setShowApprove(false);
        window.location.reload();
      }
    } catch (error) {
      showNotification(
        "An error occurred while publishing the page. Please try again.",
        "error"
      );
    }
  };
  const handleApprove = async () => {
    if (!pageView) {
      showNotification("Page data is missing. Please try again.", "error");
      return;
    }
    try {
      const response = await callApi(
        `v1/page/url/${pageView.url}/approve`,
        "get"
      );
      if (response?.status === "Success") {
        setLoader(!loader);
        showNotification("Page approved successfully", "success");
        fetchPageView();
        setShowApprove(true);
      }
    } catch (error) {
      showNotification(
        "An error occurred while publishing the page. Please try again.",
        "error"
      );
    }
  };

  const getSegmentData = (item) => {
    return item.segment_id &&
      segmentData &&
      segmentData[item.segment_id] &&
      segmentData[item.segment_id].data
      ? {
          ...segmentData[item.segment_id].data,
          segment_type: item.segment_type,
        }
      : null;
  };

  const getVersionCopyData = (item) => {
    return item.segment_id && versionCopyObject[item.segment_id]
      ? {
          ...versionCopyObject[item.segment_id],
          segment_type: item.segment_type,
        }
      : null;
  };

  // Check if any segment has is_edit = true
  const hasEditMode = pageView?.page_order?.some(
    (item) => getVersionCopyData(item)?.is_edit
  );
  const hasApproved = () => {
    return !pageView?.is_approved;
  };

  const toggleVisiblity = async (
    pageId,
    segmentId,
    selectedSegment,
    toggleValue
  ) => {
    let res = await callApi(
      `v1/page/${pageId}/segment/${segmentId}/toggle-visibility`,
      "post",
      {
        segment_type: selectedSegment,
        is_visible: toggleValue,
      }
    );
    if (res.status === "Success") {
      fetchPageView();
    }
  };

  const moveCard = (
    dragIndex: number,
    hoverIndex: number,
    dragRank: number,
    hoverRank: number,
    isDragging: boolean
  ) => {
    console.log(
      "moveCard",
      dragIndex,
      hoverIndex,
      dragRank,
      hoverRank,
      isDragging
    );
  };

const handleMetaChange = (keyName, keyValue) => {
  setMetaEdit((prev) => ({
    ...prev,
    [`updated_${keyName}`]: keyValue,
    is_meta_edited: true, 
  }));
  setErrors((prev) => ({
    ...prev,
    [`updated_${keyName}`]: "",
  }));
};

  const handleValidate = (data: any) => {
    let isValid = true;
    let error: { [index: string]: any } = {};
    if (!data?.url || data?.url === "") {
      isValid = false;
      error["url"] = "Please enter url";
    }
    // if (!data?.canonical_url || data?.canonical_url === "") {
    //   isValid = false;
    //   error["canonical_url"] = "Please enter canonical url";
    // }
    if (!data?.page_title || data?.page_title === "") {
      isValid = false;
      error["page_title"] = "Please enter page title";
    }
    if (!data?.meta_description || data?.meta_description === "") {
      isValid = false;
      error["meta_description"] = "Please enter meta description";
    }
    // if (!data?.meta_keyword || data?.meta_keyword === "") {
    //   isValid = false;
    //   error["meta_keyword"] = "Please enter meta keyword";
    // }
    return {
      isValid,
      error,
    };
  };

  const handleMetaPublish = async () => {
    try {
      const res = await callApi(
        `v1/page/${pageView?._id}/publish-metadata`,
        "post",
        {}
      );
      if (res && res?.status === "Success") {
        showNotification("Meta Data Published successfully", "success");
        fetchPageView();
      }
    } catch (e) {
      showNotification(
        e.response.data.data.message || "Error occured",
        "error"
      );
    }
  };

  const handleMetaData = async () => {
    let check = handleValidate(metaEdit);

    if (check.isValid) {
      try {
        const res = await callApi(
          `v1/page/${pageView?._id}/update-page-metaData`,
          "post",
          {
            ...metaEdit,
          }
        );
        if (res && res?.status === "Success") {
          showNotification("Updated successfully", "success");
          toggle();
          fetchPageView();
        }
      } catch (e) {
        showNotification(
          e.response.data.data.message || "Error occured",
          "error"
        );
      }
    } else {
      setErrors(check.error);
    }
  };

  const showError = (keyName) => {
    return errors && errors[keyName] ? (
      <p className="text-red-500 text-[14px]  pt-2">{errors[keyName]}</p>
    ) : null;
  };

  return (
    <React.Fragment>
      <div className="flex flex-col gap-2 py-4 md:flex-row md:items-center print:hidden">
        {/* <div className="grow">
          <h5 className="text-16">{`Editing Page with Title ${pageView?.title}`}</h5>
        </div> */}
        <div className="grow">
          <ul className="flex items-center gap-2 text-sm font-normal shrink-0">
            <li className="relative before:content-['\ea54'] before:font-remix ltr:before:-right-1 rtl:before:-left-1  before:absolute before:text-[18px] before:-top-[3px] ltr:pr-4 rtl:pl-4 before:text-slate-400 dark:text-zink-200">
              <Link
                to={PAGE_LIST_ROUTE}
                className="text-slate-400 dark:text-zink-200"
              >
                Page
              </Link>
            </li>
            <li className="text-slate-700 dark:text-zink-100">{` ${_.upperFirst(
              pageView?.url.replace("-", " ")
            )}`}</li>
          </ul>
        </div>
        {userHasPermissionToApprovePage() &&
          !showApprove &&
          hasEditMode &&
          hasApproved() && (
            <div
              className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              onClick={handleApprove}
            >
              Approve
            </div>
          )}
        {userHasPermissionToPublishPage() && hasEditMode && !hasApproved() && (
          <div
            className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            onClick={handlePublish}
          >
            Publish
          </div>
        )}
        <div
          onClick={toggle}
          className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
        >
          Edit Meta
        </div>
        <div
          onClick={() => setIsOrderVisible(true)}
          className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
        >
          Edit Order
        </div>
      </div>
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 2xl:col-span-12">
          {pageView?.page_order?.map((item, index) => (
            <EditableView
              moveCard={moveCard}
              toggleVisiblity={toggleVisiblity}
              isEditable={userHasPermissionToEditPage()}
              pageType={"page"}
              key={index}
              loader={loader}
              setLoader={setLoader}
              index={index}
              pageId={pageId}
              collapse={collapse}
              handleshowSagment={() => handleshowSagment(index)}
              segmentType={item.segment_type}
              segment_id={item.segment_id}
              data={getSegmentData(item)}
              versionData={getVersionCopyData(item)}
              handleDelete={handleDelete}
            />
          ))}
          <div className="grid grid-cols-12 my-2 gap-x-5">
            <div className="col-span-12 card 2xl:col-span-12">
              <div className="p-4 ">
                <form
                  className="create-form"
                  id="create-form"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                    <div className="xl:col-span-3">
                      <select
                        value={selectedSegment}
                        onChange={handleSegmentChange}
                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      >
                        <option value="">Select Segment</option>
                        {segmentList?.map((item) => (
                          <option key={item} value={item}>
                            {_.startCase(item)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="mt-6">
                    {segments?.map((segment, index) => (
                      <div key={index} className="mt-6 segment-container">
                        <button className="px-4 py-2 mt-4 text-white bg-red-500 rounded">
                          Delete
                        </button>
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={handleAddSegment}
                    className="px-4 py-2 mt-4 text-white bg-blue-500 rounded"
                  >
                    Add Segment
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Employee Modal */}
      <Drawer
        show={show}
        onHide={toggle}
        id="defaultModal"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Edit Pages"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <MetaData
            handleMetaChange={handleMetaChange}
                modelName="page"
                metaEdit={metaEdit}
                showError={showError}
                toggleMeta={toggleMeta}
                handleMetaData={handleMetaData}
                loader={loader}
          />
        </Drawer.Body>
      </Drawer>
      <SegmentOrderModal
        isVisible={isOrderVisible}
        onClose={() => setIsOrderVisible(false)}
        pageId={pageId}
        pageView={pageView}
        loader={loader}
        setLoader={setLoader}
        getSegmentData={getSegmentData}
      />
    </React.Fragment>
  );
};

export default PageView;
